import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "../i18n/LangContext";
import { usePlaceholder } from "../lib/usePlaceholder";

// Phone-only floating consultation CTA, shown after the hero and hidden near the final CTA.
export const MobileCTA = () => {
  const { t } = useLang();
  const ph = usePlaceholder("consultation");
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => {
      const f = document.getElementById("final")?.getBoundingClientRect();
      const nearFinal = f ? f.top < window.innerHeight : false;
      setShow(window.scrollY > window.innerHeight * 0.8 && !nearFinal);
    };
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ y: 90, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 90, opacity: 0 }} transition={{ duration: 0.5 }} className="fixed inset-x-4 bottom-4 z-40 md:hidden">
          <a {...ph} data-testid="mobile-sticky-cta" className="btn-primary w-full justify-center shadow-[0_20px_50px_-15px_rgba(0,0,0,0.6)]">
            <span className="relative z-10">{t.hero.cta1}</span>
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
